<div class="navbar">
    <!-- This is the hamburger menu that triggers below 370px -->
    <div class="mobile-version__drawer-container">
        <button mat-button class="menu-button" (click)="sidenav.toggle()">
            <mat-icon>{{ isMenuOpen ? "menu_open" : "menu" }}</mat-icon>
        </button>
        <mat-sidenav-container class="sidenav-container">
            <mat-sidenav #sidenav autoFocus="false" mode="over" [(opened)]="isMenuOpen" class="sidenav"
                (click)="onSidenavClick()">
                <div class="drawer__buttons">
                    <mat-accordion>
                        <mat-expansion-panel class="sidenav-accordion" (opened)="panelOpenState = true"
                            (closed)="panelOpenState = false">
                            <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState">
                                <mat-panel-title class="sidenav-accordion">
                                    <div class="panel-title">
                                        <img src="../../../../assets/icons/registru.svg" alt="" />
                                        <span>Registratură</span>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <p *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.list')" class="menu-link"
                                routerLink="/cereri" [class.menu-active]="'/cereri' === activeRoute"
                                (click)="setActiveRoute('/cereri')">
                                <img class="sidenav-request-btn" src="../../../../assets/icons/cereri.svg" alt="" />
                                <span>Cereri</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('dgaspc-module.documents.official-documents-registry.list')"
                                class="menu-link" routerLink="/confirmare-documente"
                                [class.menu-active]="'/confirmare-documente' === activeRoute"
                                (click)="setActiveRoute('/confirmare-documente')">
                                <img src="../../../../assets/icons/confirmed-docs.svg" alt="" />
                                <span>Confirmare Documente</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('dgaspc-module.notificari.list')"
                                class="menu-link" routerLink="/notificari"
                                [class.menu-active]="'/notificari' === activeRoute"
                                (click)="setActiveRoute('/notificari')">
                                <img src="../../../../assets/icons/notificari.svg" alt="" />
                                <span>Notificări</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('dgaspc-module.activities.list')"
                                class="menu-link" routerLink="/programari-calendar"
                                [class.menu-active]="'/programari-calendar' === activeRoute"
                                (click)="setActiveRoute('/programari-calendar')">
                                <img src="../../../../assets/icons/programari.svg" alt="" />
                                <span>Programări</span>
                            </p>
                            <p class="settings-option-menu" routerLink="/settings"
                                [class.menu-active]="'/settings' === activeRoute" (click)="setActiveRoute('/settings')">
                                <img src="../../../../assets/icons/setari.svg" alt="" />
                                <span>Setări</span>
                            </p>
                        </mat-expansion-panel>

                        <mat-expansion-panel *ngIf="env.production !== true" class="sidenav-accordion"
                            (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                            <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState">
                                <mat-panel-title class="sidenav-accordion">
                                    <div class="panel-title">
                                        <img src="../../../../assets/icons/programari.svg" alt="" />
                                        <span>Activități</span>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <p *ngIf="permissionsService.hasPermission('dgaspc-module.programari.list-all')"
                                class="menu-link" routerLink="/contracte-programari"
                                [class.menu-active]="'/contracte-programari' === activeRoute"
                                (click)="setActiveRoute('/contracte-programari')">
                                <img src="../../../../assets/icons/programari.svg" alt="" />
                                <span>Contracte programări</span>
                            </p>
                            <!-- <p *ngIf="permissionsService.hasPermission('dgaspc-module.copii.list')" class="menu-link"
                                routerLink="/copii" [class.menu-active]="'/copii' === activeRoute"
                                (click)="setActiveRoute('/copii')">
                                <img src="../../../../assets/icons/user-icon.svg" alt="" />
                                <span>Copii</span>
                            </p> -->
                            <p *ngIf="permissionsService.hasPermission('dgaspc-module.copii.list')" class="menu-link"
                                routerLink="/beneficiari" [class.menu-active]="'/beneficiari' === activeRoute"
                                (click)="setActiveRoute('/beneficiari')">
                                <img src="../../../../assets/icons/user-icon.svg" alt="" />
                                <span>Beneficiari</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('dgaspc-module.scans.list')" class="menu-link"
                                routerLink="/scans" [class.menu-active]="'/scans' === activeRoute"
                                (click)="setActiveRoute('/scans')">
                                <img src="../../../../assets/icons/docs.svg" alt="" />
                                <span>Scanări</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('dgaspc-module.program.list')" class="menu-link"
                                routerLink="/program" [class.menu-active]="'/program' === activeRoute"
                                (click)="setActiveRoute('/program')">
                                <img src="../../../../assets/icons/borderou.svg" alt="" />
                                <span>Program</span>
                            </p>
                            <p *ngIf="permissionsService.hasPermission('dgaspc-module.inregistrare-programare.list')"
                                class="menu-link" routerLink="/inregistrare-programare"
                                [class.menu-active]="'/inregistrare-programare' === activeRoute"
                                (click)="setActiveRoute('/inregistrare-programare')">
                                <img src="../../../../assets/icons/registru.svg" alt="" />
                                <span>Înregistrare Programare</span>
                            </p>
                            <p class="settings-option-menu" routerLink="/settings-activities"
                                [class.menu-active]="'/settings-activities' === activeRoute"
                                (click)="setActiveRoute('/settings-activities')">
                                <img src="../../../../assets/icons/setari.svg" alt="" />
                                <span>Setări - Beneficiari</span>
                            </p>
                            <p class="settings-option-menu" routerLink="/settings-activities-docs"
                                [class.menu-active]="'/settings-activities-docs' === activeRoute"
                                (click)="setActiveRoute('/settings-activities-docs')">
                                <img src="../../../../assets/icons/setari.svg" alt="" />
                                <span>Setări - Documente</span>
                            </p>
                            <p class="settings-option-menu" routerLink="/settings-activities-prog"
                                [class.menu-active]="'/settings-activities-prog' === activeRoute"
                                (click)="setActiveRoute('/settings-activities-prog')">
                                <img src="../../../../assets/icons/setari.svg" alt="" />
                                <span>Setări - Programări</span>
                            </p>
                        </mat-expansion-panel>

                        <mat-expansion-panel class="sidenav-accordion" (opened)="panelOpenState = true"
                            (closed)="panelOpenState = false">
                            <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState">
                                <mat-panel-title class="sidenav-accordion">
                                    <div class="panel-title">
                                        <img src="../../../../assets/icons/administrative.svg" alt="" />
                                        <span>Administrativ</span>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <p routerLink="/admin-settings" class="settings-option-menu"
                                [class.menu-active]="'/admin-settings' === activeRoute"
                                (click)="setActiveRoute('/admin-settings')">
                                <img src="../../../../assets/icons/setari.svg" alt="" />
                                <span>Setări</span>
                            </p>
                        </mat-expansion-panel>
                    </mat-accordion>

                    <div class="footer">
                        <div class="logout-button" (click)="logout()">
                            <img src="assets/icons/logout.svg" alt="Deconectare" />
                            <div class="logout-button--text">Deconectare</div>
                        </div>
                    </div>
                </div>
            </mat-sidenav>
            <mat-sidenav-content>
                <main>
                    <!-- <router-outlet></router-outlet> -->
                </main>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </div>




    <!-- <div class="d-flex flex-column hide-content">
        <div class="userdir">
            <span>{{ userDirectie }}</span>
        </div>
        <div class="usercomp">
            <span>{{ userCompartiment }}</span>
        </div>
    </div> -->
    <div class="hide-content">
        <!-- Directie Type Switcher Component -->
        <app-directie-type-switcher></app-directie-type-switcher>
    </div>

    <div class="d-flex flex-column">
        <div class="username clickable" (click)="navigateToProfile()" matTooltip="Vizualizare profil">{{ username }}
        </div>
        <!-- Job Type Switcher Component -->
        <app-job-type-switcher></app-job-type-switcher>
    </div>
    <div class="username__icon">
        <div class="username__icon clickable" (click)="navigateToProfile()" matTooltip="Vizualizare profil">
            <div class="username__icon--letters">{{ usernameLetters }}</div>
        </div>
    </div>
    <div class="notification" [popover]="popTemplateNotifications" [adaptivePosition]="true"
        #notificationsPopover="bs-popover" placement="bottom" container="body" boundariesElement="scrollParent">
        <div class="notifications" [ngClass]="{ 'move-up': !userNotifications && !isLoading }">
            <mat-spinner color="primary" diameter="40" *ngIf="isLoading"></mat-spinner>
            <img src="assets/icons/icon-bell.svg" alt="Notificari" />
            <div class="notifications--chip" [ngClass]="{ 'hide-chip': isLoading }">
                <span *ngIf="!isLoading && userNotifications">{{ userNotifications }}</span>
            </div>
        </div>
    </div>

    <ng-template #popTemplateNotifications>
        <p class="title">Aveți {{ userNotifications }} notificări</p>
        <div class="notification-popup d-flex flex-column">
            <div class="notification-message-container">
                <button type="button"
                    class=" btn btn-light subtitle d-flex justify-content-start align-items-center gap-2"
                    (click)="onButtonClick({id: '1', name: 'Cereri'})">
                    <i class="fa-solid fa-envelope info"></i> {{notification['urbanism_modified']}} Cereri necesită
                    atenția dvs.
                </button>

                <button type="button"
                    class="btn btn-light subtitle d-flex justify-content-start align-items-center gap-2"
                    (click)="onButtonClick({id: '2', name: 'Mesaje interne'})">
                    <i class="fa-solid fa-triangle-exclamation warning"></i> {{notification['urbanism_messages']}}
                    Mesaje interne pentru dvs.
                </button>
            </div>
        </div>
    </ng-template>
</div>